import { IsBoolean, IsString } from "class-validator";

export class TemplateGoodsRecipientFieldDto {
  @IsBoolean()
  required!: boolean;

  @IsString()
  type!: string;

  @IsBoolean()
  visible!: boolean;
}
